import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Snapshot, SnapshotSpectralMask } from 'types';

export const getMask = async ({
  snapshotId,
  maskId,
}: {
  snapshotId: number;
  maskId: number;
}): Promise<SnapshotSpectralMask> => {
  const { data }: { data: Snapshot } = await axios.get(
    `/api/snapshots/${snapshotId}`
  );
  const mask = data?.masks.find((mask) => mask.id === maskId);
  return mask as SnapshotSpectralMask;
};

type QueryFnType = typeof getMask;

type UseMaskOptions = {
  snapshotId: number;
  maskId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useMask = ({ snapshotId, maskId, config }: UseMaskOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['snapshot', snapshotId, 'masks', maskId],
    queryFn: () => getMask({ snapshotId, maskId }),
  });
};
